'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.endOfWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/endOfWeek.js
// module id = 492
// module chunks = 0